import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "1. About These Terms",
    body: "These terms govern your use of the Ocean Mind AI website (www.oceanmindai.co.uk) and any services we provide. Ocean Mind AI is based at 4th Floor, 45 Silver Stream House, Fitzroy Street, Fitzrovia, London, W1T 6EB, United Kingdom. By using this website you accept these terms. Contact: team@oceanmindai.co.uk · 020 3757 2456.",
  },
  {
    title: "2. Our Services",
    body: "Ocean Mind AI provides AI automation consulting, development and integration services. Specific engagements are governed by individual statements of work or service agreements, which take precedence over these website terms where they conflict.",
  },
  {
    title: "3. Website Content",
    body: "All content on this website — including text, design, graphics and code — is the property of Ocean Mind AI and may not be reproduced without written permission. Information on this site is provided for general purposes and does not constitute professional advice or a binding offer.",
  },
  {
    title: "4. Acceptable Use",
    body: "You agree not to misuse this website: no attempts to gain unauthorised access, no introduction of malicious code, no scraping or automated data collection, and no use of the site in any way that breaches applicable law.",
  },
  {
    title: "5. Enquiries & Communications",
    body: "Submitting our contact form does not create a contractual relationship. We aim to respond to enquiries within one business day, but response times are not guaranteed.",
  },
  {
    title: "6. Limitation of Liability",
    body: "To the fullest extent permitted by law, Ocean Mind AI excludes liability for any indirect or consequential loss arising from use of this website. Nothing in these terms excludes liability that cannot be excluded under UK law.",
  },
  {
    title: "7. Third-Party Links",
    body: "This website may link to third-party sites (including social media platforms). We are not responsible for the content or practices of those sites.",
  },
  {
    title: "8. Governing Law",
    body: "These terms are governed by the laws of England and Wales. Any disputes are subject to the exclusive jurisdiction of the courts of England and Wales. Last updated: August 2026.",
  },
];

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#020813] text-[#E8F1F5]" data-testid="terms-page">
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-[-10%] right-[10%] w-[500px] h-[500px] rounded-full bg-[#10E59A]/[0.05] blur-[120px]" />
        <div className="absolute bottom-[5%] left-[5%] w-[600px] h-[600px] rounded-full bg-[#00F2FE]/[0.04] blur-[140px]" />
      </div>
      <div className="relative max-w-3xl mx-auto px-6 py-20 lg:py-28">
        <Link
          to="/"
          data-testid="terms-back-link"
          className="inline-flex items-center gap-2 text-sm text-[#00F2FE] hover:text-[#10E59A] transition-colors duration-300 mb-12"
        >
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <p className="text-xs tracking-[0.3em] uppercase text-[#00F2FE] mb-5">Legal</p>
        <h1 className="font-['Outfit'] font-light text-4xl sm:text-5xl tracking-tight mb-4">
          Terms & <span className="gradient-text font-medium">Conditions</span>
        </h1>
        <p className="text-sm text-[#8AA1B1] mb-14">Ocean Mind AI · www.oceanmindai.co.uk</p>
        <div className="space-y-10">
          {sections.map((s, i) => (
            <section key={i} data-testid={`terms-section-${i}`}>
              <h2 className="font-['Outfit'] font-medium text-xl text-[#E8F1F5] mb-3">{s.title}</h2>
              <p className="text-sm leading-relaxed text-[#8AA1B1]">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
